var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import axios from "axios";
import React, { useState } from "react";
import styled from "styled-components";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { loginValidationSchema } from "./validations";
import { Register } from "./Register";
import { LoginPromoPanel } from "./LoginPromoPanel";
import { Button, LinkButton } from "../../components/Elements/Button";
import { fetchLoginSource } from "../../services/authQueries";
var getDcwTarget = function () {
    var dcwTarget = "";
    if (window.location.search.includes("dcwTarget")) {
        var queryString = window.location.search;
        var urlParams = new URLSearchParams(queryString);
        try {
            var dcwTargetDecoded = decodeURIComponent(urlParams.get("dcwTarget"));
            var dcwTargetUrl = new URL(dcwTargetDecoded);
            if (dcwTargetUrl.hostname.match(/(documentcrunch.com|localhost)$/)) {
                dcwTarget = dcwTargetUrl.toString();
            }
            else {
                console.error("dcwTarget URL does not match allowed hostnames");
            }
        }
        catch (error) {
            console.error("dcwTarget URL could not parsed", error);
        }
    }
    return dcwTarget;
};
export var Login = function (_a) {
    var targetPath = _a.targetPath, invitedEmail = _a.invitedEmail, invitedUserId = _a.invitedUserId, _b = _a.inviteRedirect, inviteRedirect = _b === void 0 ? false : _b, inviteToken = _a.inviteToken, shareToEmail = _a.shareToEmail, shareToUserId = _a.shareToUserId, passwordRequirementsJSON = _a.passwordRequirementsJSON, rolloutNewPasswordFieldFlag = _a.rolloutNewPasswordFieldFlag, teamsInvitedTo = _a.teamsInvitedTo;
    var _c = useState(""), signInErrorMessage = _c[0], setSignInErrorMessage = _c[1];
    var _d = useState(""), email = _d[0], setEmail = _d[1];
    var _e = useState(false), rememberMe = _e[0], setRememberMe = _e[1];
    var _f = useState("native"), loginSource = _f[0], setLoginSource = _f[1];
    var _g = useState(false), submitting = _g[0], setIsSubmitting = _g[1];
    var _h = useState("login"), mode = _h[0], setMode = _h[1];
    var _j = useState(false), seePassword = _j[0], setSeePassword = _j[1];
    React.useEffect(function () {
        var setInitialEmail = function () {
            setEmail(getInitialEmailValue());
        };
        var setInitialMode = function () {
            if (inviteRedirect && invitedEmail && !invitedUserId) {
                setMode("register");
            }
            else if (shareToEmail && !shareToUserId) {
                setMode("register");
            }
            else {
                setMode("login");
            }
        };
        var setInitialLoginSource = function () {
            var emailValue = getInitialEmailValue();
            if (!emailValue) {
                return;
            }
            fetchLoginSource(emailValue).then(function (source) {
                setLoginSource(source);
            });
        };
        setInitialEmail();
        setInitialMode();
        setInitialLoginSource();
    }, [
        inviteRedirect,
        invitedEmail,
        invitedUserId,
        shareToEmail,
        shareToUserId,
    ]);
    var getInitialEmailValue = function () {
        if (inviteRedirect && invitedEmail) {
            return invitedEmail;
        }
        else if (shareToEmail) {
            return shareToEmail;
        }
        return "";
    };
    var renderLoginHeader = function () {
        return (_jsx("div", __assign({ className: "d-flex flex-center mb-15" }, { children: _jsx("a", __assign({ href: "/" }, { children: _jsx("img", { src: "/assets/images/document-crunch-logo.jpg", className: "h-200px", alt: "" }) })) })));
    };
    var onSignInSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, email, password, response, dcwTarget, error_1;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    e.preventDefault();
                    logFSEvent();
                    setIsSubmitting(true);
                    if (loginSource === "sso") {
                        (_b = document.getElementById("ms_login_button")) === null || _b === void 0 ? void 0 : _b.click();
                        return [2 /*return*/];
                    }
                    _a = e.currentTarget.elements, email = _a.email, password = _a.password;
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, loginValidationSchema.validate({
                            email: email.value,
                            password: password.value,
                        })];
                case 2:
                    _c.sent();
                    setSignInErrorMessage("");
                    return [4 /*yield*/, axios.post("/ajax/login/check", {
                            username: email.value,
                            password: password.value,
                            remember_me: rememberMe,
                        }, { headers: { "Content-Type": "application/json" } })];
                case 3:
                    response = _c.sent();
                    dcwTarget = getDcwTarget();
                    if (dcwTarget) {
                        location.href = dcwTarget;
                    }
                    else {
                        location.href = response.data.redirectUrl || targetPath || "/";
                    }
                    return [3 /*break*/, 6];
                case 4:
                    error_1 = _c.sent();
                    setSignInErrorMessage("Incorrect E-mail and/or Password.");
                    return [3 /*break*/, 6];
                case 5:
                    setIsSubmitting(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var renderErrorAlert = function (message) {
        return (_jsxs("div", __assign({ className: "alert alert-danger my-5", role: "alert" }, { children: [message, _jsx("button", __assign({ type: "button", className: "close", "data-dismiss": "alert", "aria-label": "Close", onClick: function () { return setSignInErrorMessage(""); } }, { children: _jsx("span", __assign({ "aria-hidden": "true" }, { children: "\u00D7" })) }))] })));
    };
    var onEmailChange = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var emailValue;
        return __generator(this, function (_a) {
            emailValue = e.currentTarget.value;
            setEmail(emailValue);
            fetchLoginSource(emailValue).then(function (source) {
                setLoginSource(source);
            });
            return [2 /*return*/];
        });
    }); };
    var renderPasswordField = function () {
        return (_jsxs("div", __assign({ className: "form-group mb-1 position-relative" }, { children: [_jsx("input", { "data-testid": "dc-user-password", id: "dc-user-password-login", className: "form-control h-auto form-control-solid py-4 pl-8 pr-0", type: seePassword ? "text" : "password", placeholder: "Password", name: "password" }), rolloutNewPasswordFieldFlag && (_jsx(ShowPasswordDiv, __assign({ className: "input-group-append" }, { children: _jsx("span", __assign({ className: "input-group-text border-0", style: { backgroundColor: "transparent" }, onClick: function () { return setSeePassword(!seePassword); } }, { children: _jsx(FontAwesomeIcon, { fixedWidth: true, fontSize: "1.25rem", style: { padding: "0.5rem" }, icon: seePassword ? faEyeSlash : faEye }) })) }))), _jsx("div", __assign({ className: "form-group d-flex flex-wrap justify-content-end align-items-center py-4 mb-0" }, { children: renderForgotPasswordLink() }))] })));
    };
    var logFSEvent = function () {
        var _a;
        (_a = window.FS) === null || _a === void 0 ? void 0 : _a.call(window, "trackEvent", {
            name: "Login",
        });
    };
    var renderInvitationAlert = function () {
        return (_jsxs("div", __assign({ className: "alert alert-success my-5", role: "alert" }, { children: ["You have been invited to join a team. Please log in!", _jsx("button", __assign({ type: "button", className: "close", "data-dismiss": "alert", "aria-label": "Close", onClick: logFSEvent }, { children: _jsx("span", __assign({ "aria-hidden": "true" }, { children: "\u00D7" })) }))] })));
    };
    var renderSharingAlert = function () {
        return (_jsxs("div", __assign({ className: "alert alert-success my-5", role: "alert" }, { children: ["A Crunch was shared with you. Please log in!", _jsx("button", __assign({ type: "button", className: "close", "data-dismiss": "alert", "aria-label": "Close", onClick: logFSEvent }, { children: _jsx("span", __assign({ "aria-hidden": "true" }, { children: "\u00D7" })) }))] })));
    };
    var renderEmailField = function () {
        return (_jsx("div", __assign({ className: "form-group mb-5" }, { children: _jsx("input", { id: "dc-user-email-login", onChange: onEmailChange, className: "form-control h-auto form-control-solid py-4 px-8", type: "text", placeholder: "Email", name: "email", autoComplete: "off", readOnly: invitedEmail.length > 0 || shareToEmail.length > 0, value: email }) })));
    };
    var renderSignInForm = function () {
        return (_jsxs("div", __assign({ className: "login-signin" }, { children: [_jsx("div", __assign({ className: "mb-10" }, { children: _jsx("h3", { children: "Sign in to Document Crunch" }) })), signInErrorMessage && renderErrorAlert(signInErrorMessage), invitedEmail && renderInvitationAlert(), shareToEmail && renderSharingAlert(), _jsxs("form", __assign({ className: "form", id: "kt_login_signin_form", onSubmit: onSignInSubmit, method: "post" }, { children: [renderEmailField(), loginSource == "native" && renderPasswordField(), renderSignInButton(), _jsxs("div", __assign({ className: "my-10 d-none" }, { children: [_jsx("span", __assign({ className: "opacity-70 mr-4" }, { children: "Don't have an account yet?" })), _jsx("a", __assign({ href: "javascript:void(0)", id: "kt_login_signup", className: "text-muted text-hover-primary font-weight-bold" }, { children: "Sign Up !" }))] }))] }))] })));
    };
    var renderForgotPasswordLink = function () {
        return (_jsx(ForgotPasswordLink, __assign({ href: "/reset-password", className: "text-muted" }, { children: "Forgot password?" })));
    };
    var renderSignInButton = function () {
        return (_jsx(_Fragment, { children: loginSource === "sso"
                ? renderSignInWithSSOButton()
                : renderNativeSignInButton() }));
    };
    var renderNativeSignInButton = function () {
        return (_jsxs(Button, __assign({ "data-testid": "native_login_button", buttonType: "primary", id: "kt_login_signin_submit", type: "submit", disabled: submitting, style: { width: "100%", padding: "0.75rem 1rem" } }, { children: [submitting && (_jsxs(_Fragment, { children: [_jsx("span", { className: "spinner-border spinner-border-sm", role: "status", "aria-hidden": "true" }), _jsx("span", __assign({ className: "ml-1" }, { children: "Signing in..." }))] })), !submitting && _jsx("span", { children: "Sign in" })] })));
    };
    var renderSignInWithSSOButton = function () {
        var searchParams = new URLSearchParams();
        searchParams.set("email", email);
        var dcwTarget = getDcwTarget();
        if (dcwTarget) {
            searchParams.set("dcwTarget", dcwTarget);
        }
        var href = "/cognito/connect?".concat(searchParams.toString());
        return (_jsx("div", __assign({ className: "ms_login" }, { children: _jsx(LinkButton, __assign({ "data-testid": "sso_login_button", linkType: "primary", id: "ms_login_button", type: "button", href: href }, { children: "Sign in with SSO" })) })));
    };
    var onRegisterCancel = function () {
        setMode("login");
    };
    var renderSignUpForm = function () {
        return (_jsx(Register, { targetPath: targetPath, inviteRedirect: inviteRedirect, invitedEmail: invitedEmail, invitedUserId: invitedUserId, inviteToken: inviteToken, shareToEmail: shareToEmail, shareToUserId: shareToUserId, passwordRequirementsJSON: passwordRequirementsJSON, onCancel: onRegisterCancel, rolloutNewPasswordFieldFlag: rolloutNewPasswordFieldFlag, teamsInvitedTo: teamsInvitedTo }));
    };
    return (_jsxs("div", __assign({ "data-testid": "login", className: "login login-4 login-signin-on d-flex flex-row-fluid", style: { minHeight: "100vh" } }, { children: [_jsx(FormColumn, { children: _jsxs("div", __assign({ className: "login-form bg-white text-center p-7 position-relative overflow-hidden" }, { children: [renderLoginHeader(), mode == "register" ? renderSignUpForm() : renderSignInForm()] })) }), _jsx(PromoColumn, { children: _jsx(LoginPromoPanel, {}) })] })));
};
// Left column: the sign-in form. Full width on small screens; fixed width on
// large screens so the promo panel can fill the remaining space.
var FormColumn = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  background-color: #fff;\n\n  @media (min-width: 992px) {\n    width: 480px;\n    flex-shrink: 0;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  background-color: #fff;\n\n  @media (min-width: 992px) {\n    width: 480px;\n    flex-shrink: 0;\n  }\n"])));
// Right column: the promo panel. Hidden below the lg breakpoint (form-only on
// mobile), fills remaining space on large screens.
var PromoColumn = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: none;\n\n  @media (min-width: 992px) {\n    display: flex;\n    flex: 1 1 0%;\n  }\n"], ["\n  display: none;\n\n  @media (min-width: 992px) {\n    display: flex;\n    flex: 1 1 0%;\n  }\n"])));
var ForgotPasswordLink = styled.a(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  :hover {\n    color: #7e8299 !important;\n  }\n"], ["\n  :hover {\n    color: #7e8299 !important;\n  }\n"])));
// This element is also styled with the bootstrap classes
var ShowPasswordDiv = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: absolute;\n  right: 0;\n  top: 0;\n  border-radius: 4px;\n\n  path {\n    width: 13px;\n  }\n\n  :hover {\n    cursor: pointer;\n    background-color: #e4e6ef;\n  }\n"], ["\n  position: absolute;\n  right: 0;\n  top: 0;\n  border-radius: 4px;\n\n  path {\n    width: 13px;\n  }\n\n  :hover {\n    cursor: pointer;\n    background-color: #e4e6ef;\n  }\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
